import { render } from "./update.vue?vue&type=template&id=6cbf0dfa"
import script from "./update.js?vue&type=script&lang=js&external"
export * from "./update.js?vue&type=script&lang=js&external"

import "./update.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__